import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FiSearch } from "react-icons/fi";
import Highlighter from "react-highlight-words";

import { ScreenContainer, Text, Input, Table } from "components";

import { actionLocationsGetAll, selectAllLocations } from "pages/locations/redux";

const LocationsList = () => {
  const oDispatch = useDispatch();
  const aLocations = useSelector(selectAllLocations);
  const [sFilter, setFilter] = useState("");
  const [aFilteredLocations, setFilteredLocations] = useState([]);

  useEffect(() => {
    oDispatch(actionLocationsGetAll());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setFilteredLocations(() => {
      return aLocations?.length
        ? aLocations
          .filter(oLocation => (oLocation.name?.toLowerCase().includes(sFilter.toLowerCase()) || oLocation.stateName?.toLowerCase().includes(sFilter.toLowerCase())))
          .map(oLocation => ({ ...oLocation, sFilter }))
        : [];
    });
  }, [aLocations, sFilter]);

  return (
    <ScreenContainer>
      <Text bold size="text-xl md:text-3xl" color="text-gray-800 dark:text-white" className="self-center">
        Listado de localidades
      </Text>
      <section className="grid grid-cols-4 rounded-lg bg-white dark:bg-gray-800 py-4 px-5 mt-5">
        <div className="relative col-span-4 md:col-span-1">
          <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
            <FiSearch className="w-5 h-5 text-gray-500 dark:text-gray-400" />
          </div>
          <Input
            withoutClass
            value={sFilter}
            floatLabel={false}
            onChange={setFilter}
            placeholder="Buscar"
            containerClassName="rounded-lg overflow-hidden"
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full pl-10 p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          />
        </div>
      </section>
      <section className="py-5">
        <Table data-testid={"LocationsTable"}>
          <Table.Header>
            <Table.Row isHeaderOrFooter>
              <Table.Col scope="col" className="px-6 py-3 text-center">
                #
              </Table.Col>
              <Table.Col scope="col" className="px-6 py-3 text-center">
                Nombre
              </Table.Col>
              <Table.Col scope="col" className="px-6 py-3 text-center hidden md:table-cell">
                Departamento
              </Table.Col>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {aFilteredLocations.length > 0 ? (
              aFilteredLocations.map((oLocation, nIndex) => (
                <Table.Row key={`${oLocation.id}_${nIndex}`}>
                  <Table.Col
                    scope="row"
                    className="text-xs md:text-sm px-2 md:px-6 py-4 font-medium text-gray-800 dark:text-white whitespace-nowrap text-center"
                  >
                    {nIndex + 1}
                  </Table.Col>
                  <Table.Col className="px-6 py-4 text-center">
                    <Highlighter
                      searchWords={[oLocation.sFilter]}
                      autoEscape={true}
                      textToHighlight={oLocation.name}
                    />
                  </Table.Col>
                  <Table.Col className="px-6 py-4 text-center hidden md:table-cell">
                    <Highlighter
                      searchWords={[oLocation.sFilter]}
                      autoEscape={true}
                      textToHighlight={oLocation.stateName}
                    />
                  </Table.Col>
                </Table.Row>
              ))
            ) : (
              <Table.Row>
                <Table.Col className="px-6 py-4 text-center" colSpan={3}>
                  <em>
                    {sFilter.length > 0
                      ? "No se encontraron resultados"
                      : "Sin localidades registradas"}
                  </em>
                </Table.Col>
              </Table.Row>
            )}
          </Table.Body>
        </Table>
      </section>
    </ScreenContainer>
  );
};

export default LocationsList;
